import { Component, OnInit, Inject, ViewChild, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppComponent } from '../app.component';
import { Observable, of } from 'rxjs';
import { EscritoriosService, DominiosService, LoteHonorarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { Paginacao, LoteHonorario, LoteHonorarioPaginado, SituacaoLote, RequestLoteHonorarioType } from '../shared/services/acordo-ressarcimento/api/models';
import { ConsultarLoteHonorarioService } from './pagamento-honorario.service';
import { LoadingService } from '../shared/services/components/loading.service';
import { Router } from '@angular/router';
import { PsModalLoadingComponent } from 'porto-seguro-guide';

@Component({
  selector: 'app-pagamento-honorario',
  templateUrl: './pagamento-honorario.component.html',
  styleUrls: ['./pagamento-honorario.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class PagamentoHonorarioComponent implements OnInit {
  public formPesquisa: FormGroup;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public status: SituacaoLote[];
  public page: Paginacao;
  public lotePaginado: LoteHonorarioPaginado;
  public dadosLote: LoteHonorario[];
  public lotes: LoteHonorario[];
  source = [];
  columnsTemplate = [];
  public selected = '';
  public loadingLista = false;
  public numeroLote = {};
  public formLote: FormGroup;
  public flagNotaFiscal: boolean;
  public flagDetalheHonorario: boolean;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public escritorio: any;

  @ViewChild('templateValorLote') private templateValorLote: TemplateRef<any>;
  @ViewChild('templateDataLote') private templateDataLote: TemplateRef<any>;
  @ViewChild('templateNotaFiscal') private templateNotaFiscal: TemplateRef<any>;
  @ViewChild('templateDetalheLote') private templateDetalheLote: TemplateRef<any>;
  @ViewChild('templateCancelarLote') private templateCancelarLote: TemplateRef<any>;
  @ViewChild('ModalConcluidoLote') modalConcluidoLote: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    private loading: LoadingService,
    public escritorioService: EscritoriosService,
    public loteHonorarioService: LoteHonorarioService,
    public consultarLoteHonorarioService: ConsultarLoteHonorarioService,
    private router: Router,
    public dominiosService: DominiosService,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    if( sessionStorage.getItem('codigoEscritorio') && sessionStorage.getItem('codigoEscritorio') != "" ) {
        this.codigoEscritorio = JSON.parse(sessionStorage.getItem('codigoEscritorio'));
    }
    this.nomeEscritorio = sessionStorage.getItem('nomeEscritorio');
    this.isEscritorio = JSON.parse(sessionStorage.getItem('isEscritorio'));

    this.flagNotaFiscal = JSON.parse(sessionStorage.getItem('flagNotaFiscal'));
    this.flagDetalheHonorario = JSON.parse(sessionStorage.getItem('flagDetalheHonorario'));

    this.columnsTemplate = [
      { prop: 'numeroLote', label: 'N° Lote' },
      { label: 'Valor do Lote', template: this.templateValorLote },
      { label: 'Data do Lote', template: this.templateDataLote },
      { prop: 'pessoa.nomeEscritorio', label: 'Escritório' },
      { prop: 'qtdParcelas', label: 'Qtde Parcelas' },
      { prop: 'periodo', label: 'Período' },
      { prop: 'statusLote.descricaoStatus', label: 'Status do lote' },
    ];

    if (this.flagNotaFiscal) {
      this.columnsTemplate.push({ label: 'Nota Fiscal', template: this.templateNotaFiscal },);
    }

    if (this.flagDetalheHonorario) {
      this.columnsTemplate.push({ label: 'Detalhe Lote', template: this.templateDetalheLote },);
    }
    this.columnsTemplate.push({ label: 'Cancelar', template: this.templateCancelarLote },);

    this.dadosLote = undefined;
    this.lotePaginado = undefined;
    this.criarFormPesquisa();
    this.carregarStatus();
    this.criarFormLote();

    if (this.consultarLoteHonorarioService.isRealizaPesquisa
      && this.consultarLoteHonorarioService.isRealizaPesquisa() === true
      && this.consultarLoteHonorarioService.getParametrosPesquisa) {
      this.consultarLoteHonorarioService.setRealizaPesquisa(false);
      this.formPesquisa = this.consultarLoteHonorarioService.getFormPesquisa();
      this.pesquisarLote(this.consultarLoteHonorarioService.getParametrosPesquisa()['page']);
    }
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      numeroLote: null,
      anoSinistro: null,
      dataDe: null,
      dataAte: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
      codigoStatus: null,
      valorInicio: null,
      valorFinal: null
    });
  }

  private criarFormLote() {
    this.formLote = this.formBuilder.group({
      textoJustificativaReprovacao: null
    });
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );
      return of(this.nomeEscritorioFiltro);
    };
  }

  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;
    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  private carregarStatus(): void {
    this.dominiosService.obterSituacaoLote().subscribe(result => {
      this.status = result;
    });
  }

  public log(event) {
    console.log(event);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  public pesquisarLote(page) {
    this.loading.open();
    this.lotePaginado = undefined;

    if (page == undefined) {
      this.dadosLote = [];
    }

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }

    var parametros: LoteHonorarioService.ObterLotesParams = {
      numeroLote: this.tratarCondicao(this.formPesquisa.value['numeroLote']),
      anoSinistro: this.tratarCondicao(this.formPesquisa.value['anoSinistro']),
      codigoEscritorio: this.tratarCondicao(this.formPesquisa.value['codigoEscritorio']),
      situacaoLote: this.tratarCondicao(this.formPesquisa.value['codigoStatus']),
      periodoFinal: this.tratarCondicao(this.formPesquisa.value['dataAte']),
      periodoInicial: this.tratarCondicao(this.formPesquisa.value['dataDe']),
      valorFinal: this.tratarCondicao(this.formPesquisa.value['valorFinal']),
      valorInicial: this.tratarCondicao(this.formPesquisa.value['valorInicio']),
      page: page == undefined ? 0 : page,
      perPage: 10,
    };

    this.consultarLoteHonorarioService.addDadosPesquisa(parametros, this.formPesquisa);

    this.loteHonorarioService.obterLotes(parametros).subscribe(response => {
      this.loading.close();
      this.lotePaginado = response;
      this.dadosLote = this.lotePaginado.lotesHonorario;
      this.page = this.lotePaginado.paginacao;
      this.loadingLista = false;
      this.source = this.lotePaginado.lotesHonorario;
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
    });
  }

  public paginar(evt) {
    this.pesquisarLote(evt.offset);
  }

  public visualizarDetalhesHonorario(numeroLote: number) {
    console.log(numeroLote);
    this.router.navigate(['/detalhe-honorario/' + numeroLote]);
  }

  public gerarRelatorioLote() {

    this.loading.open();

    this.loteHonorarioService.obterRelatorioLote(this.dadosLote).subscribe(response => {
      if (response) {
        const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        this.appComponent.createAlert('Relatório emitido com sucesso.', 'success');
      }
      this.loading.close();
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível gerar o relatório.', 'error');
    });
  }

  public cancelarLote(numeroLote: number, ModalDialog) {

    if (this.formLote.value['textoJustificativaReprovacao'] == null || this.formLote.value['textoJustificativaReprovacao'] == '') {
      this.appComponent.createAlert("É necessário informar uma justificativa!", 'error');
      return;
    } else {
      ModalDialog.close();
      this.loading.open();

      var parametros: RequestLoteHonorarioType = {
        numeroLote: numeroLote,
        textoJustificativaReprovacao: this.formLote.value['textoJustificativaReprovacao']
      }

      this.loteHonorarioService.cancelarLote(parametros).subscribe(response => {
        this.loading.close();
        this.modalConcluidoLote.open(null);
      }, error => {
        this.loading.close();
        this.loadingLista = false;
        this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      });
    }
  }

  public openCancelarLote(numeroLote: number) {
    this.numeroLote = numeroLote;
  }

  public recarregarPagina() {
    setTimeout(() => {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.consultarLoteHonorarioService.setRealizaPesquisa(true);
        this.router.navigate(['pagamento-honorario']);
      });
    }, 500);
  }

  public downloadNotaFiscal(idArquivo, nomeArquivo) {
    this.loading.open();

    this.loteHonorarioService.obterNotaFiscalHonorario(idArquivo).subscribe(response => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

      a.href = url;
      a.download = nomeArquivo;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      this.appComponent.createAlert('Arquivo baixado com sucesso.', 'success');
      this.loading.close();
    }, error => {
      this.loading.close();
      this.loadingLista = false;
      this.appComponent.createAlert('Não foi possível baixar o arquivo.', 'error');
    });
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

  public tratarValor(valor: any) {
    if (this.formPesquisa.get(valor).value === 0
        ||  this.formPesquisa.get(valor).value === '') {
          this.formPesquisa.get(valor).setValue(null);
      }
  }

}
